import type { UploadFileFailedStatusDatagramBuf, UploadFileProgressStatusDatagramBuf, UploadFinishedStatusDatagramBuf, UploadStartedStatusDatagramBuf } from "~/classes/generated/status"
import type { UploadFileFailedStatusDatagram } from "~/models/polycache/UploadFileFailedStatusDatagram"
import type { UploadFinishedStatusDatagram } from "~/models/polycache/UploadFinishedStatusDatagram"
import type { UploadStartedStatusDatagram } from "~/models/polycache/UploadStartedStatusDatagram"

import { InterfaceFile } from "~/classes/file/InterfaceFile"
import { parseFile } from "~/utils/flatbuffers/file"
import { parseFileId } from "~/utils/flatbuffers/id"
import { parseTransferId } from "~/utils/flatbuffers/local"

const console = useLogger("transfer/upload")

export function handleUploadStartedStatusDatagramBuf(buf: UploadStartedStatusDatagramBuf) {
  const { onUploadJobStarted } = useJobs()

  const status: UploadStartedStatusDatagram = {
    transferId: parseTransferId(buf.transferId()!),
    folderId: parseFileId(buf.folderId()!),
    total: buf.total(),
    totalBytes: buf.totalBytes(),
  }
  onUploadJobStarted(status)
}

export function handleUploadFileProgressStatusDatagramBuf(
  buf: UploadFileProgressStatusDatagramBuf,
) {
  const { onUploadFileProgressStatus } = useJobs()
  const status: UploadFileProgressStatusDatagram = {
    transferId: parseTransferId(buf.transferId()!),
    fileId: parseFileId(buf.fileId()!),
    totalBytes: buf.totalBytes(),
    completedBytes: buf.completedBytes(),
  }
  onUploadFileProgressStatus(status)
}

export function handleUploadFileFailedStatusDatagramBuf(buf: UploadFileFailedStatusDatagramBuf) {
  const { notify } = useAlerts()

  const message: UploadFileFailedStatusDatagram = {
    transferId: parseTransferId(buf.transferId()!),
    file: parseFile(buf.file()!),
  }

  console.debug("Received Transfer Manager Message", message)

  // Let's send an upload file failed message to the UI. This will show up as a separate
  // alert for the failed file as opposed to a generic alert.
  const file = new InterfaceFile(message.file)
  notify({
    transferId: generateWorkerRequestId(),
    type: "error-alert",
    errorType: "upload-file-failed",
    file,
    timestamp: Date.now(),
    title: "A file failed to upload",
    description: "Details are scant right now",
  })
}

export function handleUploadFinishedStatusDatagramBuf(buf: UploadFinishedStatusDatagramBuf) {
  const { onUploadJobFinished } = useJobs()

  const status: UploadFinishedStatusDatagram = {
    transferId: parseTransferId(buf.transferId()!),
    folderId: parseFileId(buf.folderId()!),
    total: buf.total(),
    totalBytes: buf.totalBytes(),
    failed: buf.failed(),
    failedBytes: buf.failedBytes(),
  }
  onUploadJobFinished(status)
}
